// src/components/admin/services/AdminServicesManager.jsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import fetchData from '../../../api/fetchData'; // Проверь путь!
import { useTranslation } from 'react-i18next';

function AdminServicesManager({ onContentUpdated }) { 
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [servicesList, setServicesList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadServices = async () => {
    setLoading(true);
    setError(null);
    try {

      const response = await fetchData('/admin/services/admin_get_all_services.php', 'GET', null, { credentials: 'include' });
      if (response && response.status === 'success') {
        setServicesList(response.items || []);
      } else {
        setError(response?.message || 'Не удалось загрузить список услуг.');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadServices();
  }, []);

  const handleAddNewService = () => {
    navigate('/admin/services/add'); 
  };

  const handleDeleteService = async (serviceId, serviceTitle) => {
    const confirmationMessage = t('admin.services.deleteConfirmation', { title: serviceTitle, id: serviceId });
    if (window.confirm(confirmationMessage)) {
      try {
        const response = await fetchData('/admin/services/admin_delete_service.php', 'POST', { serviceId }, { credentials: 'include' });
        if (response && response.status === 'success') {
          alert(response.message);
          loadServices(); 
          if (onContentUpdated) onContentUpdated(); 
        } else {
          alert(t('admin.services.deleteError', { details: response?.message }));
        }
      } catch (err) {
        alert(t('messages.error.generic', { details: err.message }));
      }
    }
  };

  if (loading) return <p>{t('messages.loading')}</p>;
  if (error) return <p>{t('messages.error.generic', { details: error })}</p>;

return (
    <div className="admin-services-manager">
      <h4>{t('admin.services.managerTitle', 'Управление Услугами')}</h4>
      <button onClick={handleAddNewService} style={{ marginBottom: '20px' }}>
        {t('admin.services.addNewButton', 'Добавить новую услугу')}
      </button>

      {servicesList.length === 0 ? (
        <p>{t('admin.services.noItems', 'Услуг пока нет.')}</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>{t('admin.services.idLabel', 'ID')}</th>
              <th>{t('admin.services.iconLabel', 'Иконка')}</th>
              <th>{t('admin.services.titleLabel', 'Название (RU)')}</th>
              <th>{t('admin.services.actionsLabel', 'Действия')}</th>
            </tr>
          </thead>
          <tbody>
            {servicesList.map(item => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td><i className={item.icon_class}></i> ({item.icon_class})</td>
                <td>{item.title}</td>
                <td className="admin-actions">
                  <Link to={`/admin/services/edit/${item.id}`} style={{ marginRight: '10px' }}>
                    {t('admin.buttons.edit', 'Редактировать')}
                  </Link>
                  <button onClick={() => handleDeleteService(item.id, item.title)} className="delete-button">
                    {t('admin.buttons.delete', 'Удалить')}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );

}

export default AdminServicesManager;